// extracted by mini-css-extract-plugin
module.exports = {"publisher-logo":"styles-m__publisher-logo__1GwUp","divider":"styles-m__divider__JPPwO"};